import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPendingByCustomer } from '../../api';

// Nơi hàng đang nằm → nhãn ngắn + có được bay thẳng không.
// fly=true: gán chuyến được ngay. fly=false: phải chuyển lên Kho 1 trước.
const LOC_META = {
  'Kho 1':               { label: 'Kho 1',               order: 1, fly: true },
  'Kho 4':               { label: 'Kho 4',               order: 2, fly: true },
  'Kho Surrey':          { label: 'Kho Surrey',          order: 3, fly: true },
  'Đã chuyển lên Kho 1': { label: 'Đã chuyển lên Kho 1', order: 4, fly: true },
  'Kho 2':               { label: 'Kho 2',               order: 5, fly: false },
  'Kho 3':               { label: 'Kho 3',               order: 6, fly: false },
  'ARBOURRIDGE':         { label: 'ARBOURRIDGE',         order: 7, fly: false },
};
const metaOf = (loc) => LOC_META[loc] || { label: loc || 'Chưa rõ kho', order: 99, fly: false };
const STUCK_LOCS = new Set(['Kho 2', 'Kho 3', 'ARBOURRIDGE']);

export default function PendingByCustomer() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      setRows(await getPendingByCustomer());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(r =>
      (r.name || '').toLowerCase().includes(q) ||
      (r.code || '').toLowerCase().includes(q)
    );
  }, [rows, search]);

  const totals = useMemo(() => {
    let pending = 0, hold = 0, stuck = 0;
    for (const r of rows) {
      pending += r.pending_count;
      hold += r.hold_count;
      for (const l of r.by_location || []) {
        if (STUCK_LOCS.has(l.location)) stuck += l.pending_count + l.hold_count;
      }
    }
    return { customers: rows.length, pending, hold, stuck };
  }, [rows]);

  const goCustomer = (r, loc, tab) => {
    const qs = new URLSearchParams({ customer_id: String(r.customer_id) });
    if (loc) qs.set('location', loc);
    if (tab) qs.set('tab', tab);
    navigate(`/shipments/pending?${qs.toString()}`);
  };

  return (
    <div>
      <style>{`
        .pbc-search{background:var(--bg-tertiary);border:1px solid var(--border);border-radius:var(--radius-sm);padding:9px 12px 9px 34px;font-size:13px;color:var(--text-primary);font-family:var(--font-sans);outline:none;width:100%;background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><circle cx='11' cy='11' r='8'/><path d='m21 21-4.3-4.3'/></svg>");background-repeat:no-repeat;background-position:12px center;}
        .pbc-search:focus{border-color:var(--accent);box-shadow:0 0 0 3px var(--accent-bg);}
        .pbc-card{display:flex;justify-content:space-between;align-items:center;gap:20px;padding:13px 18px;border-top:1px solid var(--border);}
        .pbc-card:first-child{border-top:none;}
        .pbc-namearea{cursor:pointer;min-width:0;}
        .pbc-namearea:hover .pbc-name{color:var(--accent);}
        .pbc-code{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:12px;font-weight:600;color:var(--accent);letter-spacing:0.02em;}
        .pbc-name{font-size:13.5px;font-weight:500;color:var(--text-primary);margin-top:2px;transition:color var(--transition-fast);}
        .pbc-locs{display:flex;flex-direction:column;gap:6px;flex-shrink:0;}
        .pbc-locrow{display:grid;grid-template-columns:150px 84px 84px;align-items:center;gap:8px;cursor:pointer;padding:3px 6px;border-radius:var(--radius-sm);transition:background-color var(--transition-fast);}
        .pbc-locrow:hover{background:var(--bg-tertiary);}
        .pbc-locname{font-size:12.5px;font-weight:600;color:var(--text-primary);text-align:right;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .pbc-count{display:inline-flex;align-items:center;gap:6px;height:24px;padding:0 8px;border-radius:var(--radius-sm);font-size:12px;font-weight:600;justify-content:center;white-space:nowrap;}
        .pbc-count .lbl{font-size:9px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;opacity:0.7;}
        .pbc-pending{background:rgba(22,163,74,0.10);color:#15803d;border:1px solid rgba(22,163,74,0.22);}
        .pbc-hold{background:rgba(217,119,6,0.10);color:#a16207;border:1px solid rgba(217,119,6,0.20);}
        .pbc-zero{background:var(--bg-tertiary);color:var(--text-muted);border:1px solid var(--border);}
        .pbc-stat{background:var(--bg-secondary);border:1px solid var(--border);border-radius:var(--radius-lg);padding:12px 16px;min-width:112px;}
        .pbc-stat .n{font-size:22px;font-weight:600;color:var(--text-primary);line-height:1.1;font-variant-numeric:tabular-nums;}
        .pbc-stat .l{font-size:10px;font-weight:500;letter-spacing:0.1em;text-transform:uppercase;color:var(--text-muted);margin-top:4px;}
      `}</style>

      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',flexWrap:'wrap',gap:16,marginBottom:20}}>
        <div>
          <div className="page-eyebrow">MANAGEMENT</div>
          <h1 className="page-title">Pending by Customer</h1>
          <p className="page-subtitle">Un-flown packages per customer, split by location — click a location row to open that customer's list pre-filtered</p>
        </div>
        <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
          <div className="pbc-stat"><div className="n">{totals.customers}</div><div className="l">Customers</div></div>
          <div className="pbc-stat"><div className="n" style={{color:'#15803d'}}>{totals.pending}</div><div className="l">Pending</div></div>
          <div className="pbc-stat"><div className="n" style={{color:'#a16207'}}>{totals.hold}</div><div className="l">Hold</div></div>
          <div className="pbc-stat"><div className="n" style={{color:'#c2410c'}}>{totals.stuck}</div><div className="l">At Kho 2/3</div></div>
        </div>
      </div>

      <div style={{maxWidth:420,marginBottom:16}}>
        <input className="pbc-search" placeholder="Search customer name or code…"
          value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {error && (
        <div style={{padding:'12px 16px',background:'rgba(220,38,38,0.06)',border:'1px solid rgba(220,38,38,0.20)',borderRadius:8,color:'#b91c1c',fontSize:13,marginBottom:16}}>
          {error}
        </div>
      )}

      <div className="table-shell">
        {loading ? (
          <div style={{padding:'40px',textAlign:'center',color:'var(--text-muted)',fontSize:13}}>Loading…</div>
        ) : filtered.length === 0 ? (
          <div style={{padding:'40px',textAlign:'center',color:'var(--text-muted)',fontSize:13}}>
            {rows.length === 0 ? 'No customers with un-flown packages 🎉' : 'No customer matches your search'}
          </div>
        ) : (
          filtered.map(r => {
            const locs = [...(r.by_location || [])].sort(
              (a, b) => metaOf(a.location).order - metaOf(b.location).order
            );
            return (
              <div key={r.customer_id} className="pbc-card">
                <div className="pbc-namearea" onClick={() => goCustomer(r)} title={`Open ${r.name} — all locations`}>
                  <span className="pbc-code">{r.code || '—'}</span>
                  <div className="pbc-name">{r.name}</div>
                </div>
                <div className="pbc-locs">
                  {locs.map(l => {
                    const m = metaOf(l.location);
                    return (
                      <div key={l.location || 'unknown'} className="pbc-locrow"
                        onClick={(e) => { e.stopPropagation(); goCustomer(r, l.location, l.pending_count ? 'pending' : 'hold'); }}
                        title={`Open ${r.name} — ${m.label}`}>
                        <span className="pbc-locname">{m.label}</span>
                        <span className={`pbc-count ${l.pending_count ? 'pbc-pending' : 'pbc-zero'}`}
                          onClick={l.pending_count ? (e) => { e.stopPropagation(); goCustomer(r, l.location, 'pending'); } : undefined}>
                          <span className="lbl">Pending</span>{l.pending_count}
                        </span>
                        <span className={`pbc-count ${l.hold_count ? 'pbc-hold' : 'pbc-zero'}`}
                          onClick={l.hold_count ? (e) => { e.stopPropagation(); goCustomer(r, l.location, 'hold'); } : undefined}>
                          <span className="lbl">Hold</span>{l.hold_count}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
